module.exports = __webpack_public_path__ + "img/WellBeingMe_Logo_RGB.ae03bbeb.png";